import {
  QuestionnaireElementBlueprint,
  isFieldGroupBlueprint,
  isSectionBlueprint,
  isSubsectionBlueprint,
} from '@zinnia/form-engine-sdk';

export function removeReferenceLabelsFromElementBlueprint<T extends QuestionnaireElementBlueprint>(
  questionnaireElement: T,
): T {
  const newQuestionnaireElement = { ...questionnaireElement };
  delete newQuestionnaireElement.referenceLabel;
  if (isSectionBlueprint(newQuestionnaireElement)) {
    newQuestionnaireElement.subsections = newQuestionnaireElement.subsections.map((subsection) => {
      return removeReferenceLabelsFromElementBlueprint(subsection);
    });
  }
  if (isSubsectionBlueprint(newQuestionnaireElement)) {
    newQuestionnaireElement.fieldGroups = newQuestionnaireElement.fieldGroups.map((fieldGroup) => {
      return removeReferenceLabelsFromElementBlueprint(fieldGroup);
    });
  }
  if (isFieldGroupBlueprint(newQuestionnaireElement)) {
    newQuestionnaireElement.fields = newQuestionnaireElement.fields.map((field) => {
      return removeReferenceLabelsFromElementBlueprint(field);
    });
  }
  return newQuestionnaireElement;
}
